storefrontApp.service('machinesService', ['$http', function ($http) {
    return {
        getMachinesPageContent: function () {
            return $http.get('machines-content');
        }
    };
}]);
